// Global event system for chat updates to trigger UI refreshes
// This allows tools to notify the UI when they make changes

type ChatUpdateEvent = {
  type: 'chat-pinned' | 'chat-unpinned' | 'message-starred' | 'message-unstarred'
  data: {
    chatId?: string
    messageId?: string
    chat?: any
    thumbsUp?: boolean | null
  }
}

class ChatUpdateManager {
  private listeners: Array<(event: ChatUpdateEvent) => void> = []

  subscribe(callback: (event: ChatUpdateEvent) => void) {
    this.listeners.push(callback)
    return () => {
      this.listeners = this.listeners.filter((listener) => listener !== callback)
    }
  }

  emit(event: ChatUpdateEvent) {
    this.listeners.forEach((listener) => {
      try {
        listener(event)
      } catch (error) {
        console.error('Error in chat update listener:', error)
      }
    })
  }

  notifyChatPinned(chatId: string, chat: any) {
    this.emit({
      type: 'chat-pinned',
      data: { chatId, chat }
    })
  }

  notifyChatUnpinned(chatId: string, chat: any) {
    this.emit({
      type: 'chat-unpinned',
      data: { chatId, chat }
    })
  }

  notifyMessageStarred(messageId: string, thumbsUp: boolean | null) {
    this.emit({
      type: thumbsUp === true ? 'message-starred' : 'message-unstarred',
      data: { messageId, thumbsUp }
    })
  }
}

export const chatUpdateManager = new ChatUpdateManager()
